module.exports = __webpack_public_path__ + "static/media/fitburn.271d3589.jpg";